import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import SwapVertIcon from '@mui/icons-material/SwapVert'
import { SENSEMAKER_TABLE } from './sensemaker-table-theme'
import { tableSortNextActionLabel, type TableSortDirection } from './table-sort'

const SORT_ICON_SLOT_PX = 18
const SORT_ICON_GAP_PX = 10

interface Props {
  label: string
  sortDirection: TableSortDirection
  testId: string
  onToggle: () => void
  /** When false, label never ellipsizes (use for short/critical headers). Default true. */
  truncateLabel?: boolean
}

/** Shared sort control — icon pinned left so column reflow does not shift the hit target. */
export function SortableTableHeaderLabel({
  label,
  sortDirection,
  testId,
  onToggle,
  truncateLabel = true,
}: Readonly<Props>) {
  const tooltip = tableSortNextActionLabel(sortDirection)
  const isActive = sortDirection !== null

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          width: SORT_ICON_SLOT_PX,
          height: SORT_ICON_SLOT_PX,
          mr: `${SORT_ICON_GAP_PX}px`,
        }}
      >
        <Tooltip title={tooltip}>
          <IconButton
            size="small"
            aria-label={tooltip}
            data-testid={testId}
            onClick={onToggle}
            sx={{
              width: SORT_ICON_SLOT_PX,
              height: SORT_ICON_SLOT_PX,
              p: 0,
              color: isActive
                ? SENSEMAKER_TABLE.sortActiveColor
                : SENSEMAKER_TABLE.sortInactiveColor,
            }}
          >
            <SwapVertIcon sx={{ fontSize: SORT_ICON_SLOT_PX }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Box
        component="span"
        sx={
          truncateLabel
            ? {
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }
            : {
                flexShrink: 0,
                whiteSpace: 'nowrap',
              }
        }
      >
        {label}
      </Box>
    </Box>
  )
}
